<template>
  <svg
    width="79"
    height="76"
    viewBox="0 0 79 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        id="front-reflection-blur"
        y="0.734375"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2.5"
          result="effect1_foregroundBlur_2992_1696"
        />
      </filter>
      <filter id="animated-blur-primary" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="9.93906;15.893;35.2152;33.3447;14.7676;10.1396;15.7324;19.7969;18.0322;11.8789;9.93906"
        />
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="33s"
          values="31.17;24.3998;26.4145;22.8428;10.9678;19.5625;20.2339;13.1187;19.6895;31.5488;31.17"
        />
      </filter>
      <filter id="animated-blur-secondary" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="10.9258;11.2266;18.1906;22.7256;14.3701;11.2939;17.5742;32.0029;14.1045;18.8066;10.9258"
        />
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="33s"
          values="23.437;16.2461;16.6789;17.8647;18.1436;30.7812;16.9209;20.1973;11.0586;13.9438;23.437"
        />
      </filter>
      <filter id="animated-blur-tertiary" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="14.8691;18.0547;23.5871;25.458;23.0889;24.8027;10.1473;21.2881;26.1904;11.6426;14.8691"
        />
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="33s"
          values="15.7109;13.6533;8.01387;10.728;7.82568;4.47021;12.9876;5.82861;11.7822;9.00293;15.7109"
        />
      </filter>
      <filter id="animated-blur-quaternary" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="23.1758;13.3125;6.95215;10.0752;9.48438;8.65742;9.56953;12.7588;12.533;24.459;23.1758"
        />
        <animate
          attributeName="y"
          repeatCount="indefinite"
          dur="33s"
          values="20.2812;26.1348;27.9487;20.2866;9.40723;11.6569;9.57002;10.8584;11.3416;15.4028;20.2812"
        />
      </filter>
      <filter id="animated-blur-final" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="8.21328;6.59102;18.3957;19.0781;14.458;11.3529;7.94863;7.07715;8.39648;8.86211;8.21328"
        />
      </filter>
      <filter
        id="decorative-blur-alpha"
        y="0.734375"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="1.92188;1.92188;1.92285;1.92285;1.92285;1.92285;1.92285;1.92285;1.92285;1.92188;1.92188"
        />
      </filter>
      <filter
        id="decorative-blur-beta"
        y="10.6768"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <animate
          attributeName="x"
          repeatCount="indefinite"
          dur="33s"
          values="48.5996;48.5996;48.5996;48.5986;48.5986;48.5986;48.5986;48.5986;48.5996;48.5996;48.5996"
        />
      </filter>
      <radialGradient
        id="avatar-background-gradient"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.5 38.5) rotate(89.493) scale(56.5022 66.9846)"
      >
        <stop offset="0.124" stop-color="#DDECDE" />
        <stop offset="0.394328" stop-color="#DDECDE" />
        <stop offset="0.99" stop-color="#B8D6BE" />
      </radialGradient>
      <linearGradient
        id="avatar-stroke-gradient"
        x1="-37"
        y1="-43.5"
        x2="75.5"
        y2="79.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DDECDE" />
        <stop offset="0.53483" stop-color="#E8F2E9" />
        <stop offset="1" stop-color="#DDECDE" />
      </linearGradient>
      <radialGradient
        id="animated-gradient-primary"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37 37) scale(40)"
      >
        <stop offset="0.3" stop-color="#DDECDE">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#DDECDE;#F4EDFA;#E8DAF4;#DBF9FF;#DDECDE;#DBF9FF;#DDECDE;#F2FDFF;#B6EDFA;#DDECDE;#DDECDE"
          />
        </stop>
        <stop offset="0.6" stop-color="#C196DC">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#C196DC;#B761ED;#9156B4;#85D4EE;#C196DC;#C37BF0;#85D4EE;#51B9DA;#83DBEF;#C196DC;#C196DC"
          />
        </stop>
        <stop offset="0.85" stop-color="#E8DAF4">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#E8DAF4;#F4EDFA;#E8DAF4;#DDECDE;#85D4EE;#F4EDFA;#DBF9FF;#F4EDFA;#E8DAF4;#DDECDE;#E8DAF4"
          />
        </stop>
      </radialGradient>
      <radialGradient
        id="animated-gradient-secondary"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38 40) scale(35)"
      >
        <stop offset="0.25" stop-color="#E8DAF4">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#E8DAF4;#F2F7F3;#F2F7F3;#E8DAF4;#DDECDE;#F4EDFA;#F2FDFF;#F2F7F3;#85D4EE;#E8DAF4;#E8DAF4"
          />
        </stop>
        <stop offset="0.65" stop-color="#C196DC">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#C196DC;#C196DC;#CF8AF8;#B872E2;#DBA3FF;#B8D6BE;#74C788;#77D28D;#8AD19B;#BC6DED;#C196DC"
          />
        </stop>
        <stop offset="0.9" stop-color="#F2F7F3">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#F2F7F3;#F2F7F3;#C196DC;#F4EDFA;#F4EDFA;#F2F7F3;#F2F7F3;#7BB589;#E2D0F2;#E8DAF4;#F2F7F3"
          />
        </stop>
      </radialGradient>
      <radialGradient
        id="animated-gradient-tertiary"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38 38) scale(38)"
      >
        <stop offset="0.2" stop-color="#DBF9FF">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#DBF9FF;#B8D6BE;#F2F7F3;#F2FDFF;#B8D6BE;#F2F7F3;#DDECDE;#DBF9FF;#DBF9FF;#DBF9FF;#DBF9FF"
          />
        </stop>
        <stop offset="0.6" stop-color="#32AF55">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#32AF55;#2AA34C;#2FA851;#4AC66D;#85D4EE;#4DB96B;#67B87D;#58B69B;#3BCAF7;#51B9DA;#32AF55"
          />
        </stop>
        <stop offset="0.9" stop-color="#96DAA3">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#96DAA3;#C9E9CF;#DBF9FF;#DBF9FF;#DBF9FF;#B8D6BE;#85D4EE;#85D4EE;#DBF9FF;#DDECDE;#96DAA3"
          />
        </stop>
      </radialGradient>
      <radialGradient
        id="animated-gradient-quaternary"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38 38) scale(45)"
      >
        <stop offset="0.1" stop-color="#FFFFFF">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#FFFFFF;#FFFFFF;#FFFFFF;#FFFFFF;#DBF9FF;#DBF9FF;#DBF9FF;#FFFFFF;#F4EDFA;#FFFFFF;#FFFFFF"
          />
        </stop>
        <stop offset="0.35" stop-color="#E8DAF4">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#E8DAF4;#E8DAF4;#E8DAF4;#E8DAF4;#5FD2F7;#63D3F7;#D9D7FB;#F9F6FD;#FFFFFF;#9EECFF;#E8DAF4"
          />
        </stop>
        <stop offset="0.6" stop-color="#61CDEF">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#61CDEF;#55CBF0;#7CCFE9;#85D4EE;#DBF9FF;#E8DAF4;#D6A5F4;#BF77ED;#BE74EC;#C17DEC;#61CDEF"
          />
        </stop>
        <stop offset="0.85" stop-color="#E8DAF4">
          <animate
            attributeName="stop-color"
            repeatCount="indefinite"
            dur="33s"
            values="#E8DAF4;#85D4EE;#DBF9FF;#DBF9FF;#DBF9FF;#DBF9FF;#E8DAF4;#E8DAF4;#B6EDFA;#DBF9FF;#E8DAF4"
          />
        </stop>
      </radialGradient>
    </defs>

    <circle
      cx="37.5"
      cy="38.5"
      r="37"
      fill="url(#avatar-background-gradient)"
      stroke="url(#avatar-stroke-gradient)"
    />
    <g opacity="0.5">
      <path
        d="M70.3462 38.0649C70.3462 44.4375 62.8462 65.3597 39.4808 67.7766C22.75 69.5072 11.5 60.3028 11.5 53.9303C11.5 47.5577 28.5353 42.1035 42.0769 42.1035C55.6185 42.1035 70.3462 31.6924 70.3462 38.0649Z"
        fill="#B6EDFA"
      />
    </g>
    <g filter="url(#animated-blur-primary)">
      <path fill="url(#animated-gradient-primary)">
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="33s"
          values="M61.7769 42.0077C59.8942 56.232 46.837 66.2369 32.6127 64.3542C18.3884 62.4716 8.38352 49.4143 10.2662 35.19C12.1488 20.9658 28.2634 49.886 42.4877 51.7686C56.712 53.6512 63.6595 27.7834 61.7769 42.0077Z;M56.6339 27.9456C60.1185 38.9819 53.9966 50.7535 42.9602 54.2381C31.9238 57.7227 20.1523 51.6008 16.6677 40.5644C13.1831 29.528 34.8388 45.1528 45.8752 41.6682C56.9116 38.1836 53.1493 16.9092 56.6339 27.9456Z;M51.0126 27.6829C59.2888 31.3945 62.9892 41.1127 59.2775 49.389C55.5659 57.6652 45.8477 61.3656 37.5714 57.6539C29.2952 53.9423 49.727 49.4083 53.4386 41.132C57.1503 32.8557 42.7363 23.9712 51.0126 27.6829Z;M36.4029 23.3595C45.0827 22.9647 52.4391 29.681 52.8339 38.3607C53.2287 47.0405 46.5124 54.3969 37.8326 54.7917C29.1529 55.1865 44.6733 42.4963 44.2785 33.8166C43.8837 25.1368 27.7232 23.7543 36.4029 23.3595Z;M16.4886 25.4293C21.7215 13.5943 35.5577 8.24218 47.3927 13.475C59.2277 18.7078 64.5798 32.544 59.347 44.379C54.1142 56.214 47.4921 27.0998 35.6571 21.867C23.8221 16.6342 11.2558 37.2644 16.4886 25.4293Z;M11.6026 51.2203C7.86729 38.2796 15.3297 24.761 28.2704 21.0257C41.2111 17.2903 54.7297 24.7527 58.465 37.6934C62.2004 50.6341 37.4566 31.8303 24.5159 35.5657C11.5752 39.3011 15.338 64.161 11.6026 51.2203Z;M25.0005 65.2973C14.404 56.1247 13.2497 40.0987 22.4223 29.5022C31.5949 18.9058 47.6209 17.7515 58.2174 26.9241C68.8138 36.0967 36.5635 33.7205 27.3909 44.317C18.2183 54.9135 35.5969 74.4699 25.0005 65.2973Z;M45.4524 67.2336C30.6617 66.3064 19.4232 53.5646 20.3504 38.774C21.2776 23.9833 34.0194 12.7448 48.8101 13.6719C63.6007 14.5991 34.9488 33.2625 34.0216 48.0531C33.0944 62.8438 60.2431 68.1608 45.4524 67.2336Z;M54.6722 57.0719C44.8457 64.6324 30.7507 62.7954 23.1902 52.9688C15.6297 43.1422 17.4667 29.0472 27.2932 21.4867C37.1198 13.9262 29.3502 41.4587 36.9107 51.2853C44.4712 61.1118 64.4988 49.5114 54.6722 57.0719Z;M55.3679 53.6381C50.1385 64.9319 36.7438 69.8481 25.45 64.6187C14.1562 59.3893 9.24001 45.9946 14.4694 34.7008C19.6988 23.407 25.5815 51.5148 36.8753 56.7442C48.1691 61.9736 60.5973 42.3443 55.3679 53.6381Z;M61.7769 42.0077C59.8942 56.232 46.837 66.2369 32.6127 64.3542C18.3884 62.4716 8.38352 49.4143 10.2662 35.19C12.1488 20.9658 28.2634 49.886 42.4877 51.7686C56.712 53.6512 63.6595 27.7834 61.7769 42.0077Z"
        />
      </path>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="33s"
        values="1;0.85;0.85;0.85;0.85;0.9;0.9;0.9;0.9;0.9;1"
      />
    </g>
    <g filter="url(#animated-blur-secondary)">
      <path fill="url(#animated-gradient-secondary)">
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="33s"
          values="M11.9949 47.5824C12.7025 34.1107 24.1971 23.7634 37.6687 24.471C51.1404 25.1787 61.4877 36.6732 60.7801 50.1449C60.0725 63.6165 42.8201 37.7083 29.3485 37.0007C15.8768 36.2931 11.2873 61.0541 11.9949 47.5824Z;M13.4564 52.0586C8.31563 38.6527 15.0158 23.6176 28.4217 18.4769C41.8276 13.3361 56.8627 20.0363 62.0035 33.4422C67.1443 46.8481 39.1584 29.1198 25.7525 34.2606C12.3466 39.4014 18.5972 65.4646 13.4564 52.0586Z;M34.9935 65.5668C22.1323 60.7077 15.6453 46.3425 20.5045 33.4813C25.3636 20.6201 39.7288 14.1331 52.59 18.9923C65.4512 23.8514 34.9526 32.579 30.0935 45.4402C25.2343 58.3014 47.8547 70.426 34.9935 65.5668Z;M47.5872 62.2467C35.4865 63.5318 24.6352 54.764 23.3502 42.6633C22.0651 30.5626 30.8329 19.7114 42.9336 18.4263C55.0343 17.1413 34.4091 36.1926 35.6941 48.2933C36.9791 60.3939 59.6878 60.9617 47.5872 62.2467Z;M61.4839 38.4595C56.8536 50.9134 43.0041 57.2557 30.5502 52.6253C18.0963 47.995 11.754 34.1455 16.3843 21.6916C21.0146 9.23772 29.6046 38.6672 42.0585 43.2975C54.5124 47.9278 66.1142 26.0056 61.4839 38.4595Z;M64.0046 35.4564C66.3262 49.8309 56.5553 63.3658 42.1808 65.6873C27.8063 68.0089 14.2714 58.238 11.9499 43.8635C9.62833 29.489 33.731 52.8945 48.1056 50.5729C62.4801 48.2514 61.6831 21.0819 64.0046 35.4564Z;M51.6101 19.6226C62.871 28.2393 65.0146 44.3533 56.3979 55.6141C47.7812 66.875 31.6672 69.0185 20.4063 60.4018C9.14545 51.7851 41.8595 52.217 50.4762 40.9561C59.0929 29.6953 40.3493 11.0059 51.6101 19.6226Z;M35.9703 21.0408C47.931 18.9139 59.3513 26.8858 61.4782 38.8465C63.605 50.8073 55.6331 62.2275 43.6724 64.3544C31.7117 66.4813 50.9179 46.0647 48.7911 34.104C46.6642 22.1433 24.0096 23.1677 35.9703 21.0408Z;M18.3759 19.27C30.6049 8.6274 49.146 9.91351 59.7886 22.1426C70.4311 34.3716 69.145 52.9127 56.916 63.5553C44.6869 74.1978 52.6564 37.6508 42.0139 25.4218C31.3713 13.1927 6.14682 29.9125 18.3759 19.27Z;M20.2145 27.0507C24.2095 16.8504 35.7171 11.82 45.9173 15.815C56.1176 19.8101 61.148 31.3176 57.153 41.5179C53.1579 51.7182 46.4974 27.335 36.2971 23.34C26.0968 19.345 16.2195 37.251 20.2145 27.0507Z;M11.9949 47.5824C12.7025 34.1107 24.1971 23.7634 37.6687 24.471C51.1404 25.1787 61.4877 36.6732 60.7801 50.1449C60.0725 63.6165 42.8201 37.7083 29.3485 37.0007C15.8768 36.2931 11.2873 61.0541 11.9949 47.5824Z"
        />
      </path>
    </g>
    <g filter="url(#animated-blur-tertiary)">
      <path fill="white" fill-opacity="0.5">
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="33s"
          values="M46.7544 34.5915C47.4621 21.1199 -1.43471 19.8062 26.4931 18.711C39.9647 19.4186 40.3432 46.8573 39.6356 60.3289C37.7191 69.9119 40.7308 56.1902 27.8622 50.7458C6.50555 41.7103 44.0164 46.365 46.7544 34.5915Z;M55.548 32.7142C56.2901 18.586 3.57475 32.7142 25.3156 17.1053C43.7751 6.58399 43.9956 56.5473 39.0986 60.7513C32.0021 65.7359 28.4196 74.4998 25.3152 60.7514C19.5009 34.9999 52.6766 45.0614 55.548 32.7142Z;M50.0429 43.2635C50.0429 30.0943 25.4606 30.6796 27.9665 19.2229C40.3856 -8.82785 45.9456 55.8474 42.0136 63.7054C34.781 68.7855 25.5881 62.6219 34.8251 57.018C65.9993 46.5 52.4997 49.5 50.0429 43.2635Z;M33.5329 41.3486C43.4667 27.9887 25.2848 22.875 28.3007 18.8977C41.194 -6.10242 48.0121 59.5229 41.9371 62.0797C31.8185 74.5798 32.3868 70.0343 34.9588 55.5878C80.9668 32.5341 21.0329 47.5986 33.5329 41.3486Z;M25.9572 41.5322C36.3728 27.5243 53.3613 -2.85075 35.489 15.6173C30.4252 21.2769 45.3188 43.6173 34.8935 59.1066C24.2841 72.213 35.4891 70.1279 49.7867 62.0854C84.9359 36.1705 16.7232 57.0216 25.9572 41.5322Z;M31.7372 35.1927C45.123 21.1555 75.2373 3.69263 36.7435 9.67985C11.2376 21.6926 56.8283 18.1926 39.9997 57.0002C35.2129 68.0386 45.2105 57.5608 55.1368 65.7356C80.245 52.3055 16.7445 50.0825 31.7372 35.1927Z;M15.6616 44.8436C23.0162 44.8436 94.4463 23.178 31.415 16.7874C4.12532 24.8662 75.9714 59.2971 34.5527 59.2971C21.0076 59.2971 6.37646 63.6956 48.0194 64.821C92.4762 33.026 0.467236 58.9122 15.6616 44.8436Z;M35.4995 29.0002C44.9994 23.4547 29.7263 1.79392 26.4998 13.0002C19.9857 35.6259 85.8519 43.6215 31.8721 54.9123C19.4995 57.5002 26.4992 67.5002 36.9994 64.5001C81.4994 43.0001 12.4994 45.9547 35.4995 29.0002Z;M46.8253 35.9325C70.4415 29.7324 42.7685 10.4572 30.476 16.4086C24.7195 21.8452 52.9235 39.1516 39.7118 49.8258C26.5001 60.5 30.4764 73.5 47.9888 64.4056C65.5012 55.3111 5.01192 46.9099 46.8253 35.9325Z;M19.4993 42.4999C53.0786 36.4338 40.999 -3 30.0702 19.2399C14.499 42.4999 93.4996 57.4999 24.0088 59.6766C24.0088 59.6766 34.5781 65.4392 50.9166 61.4954C90.9996 43.9999 -6.0719 47.1193 19.4993 42.4999Z;M46.7544 34.5915C47.4621 21.1199 -1.43471 19.8062 26.4931 18.711C39.9647 19.4186 40.3432 46.8573 39.6356 60.3289C37.7191 69.9119 40.7308 56.1902 27.8622 50.7458C6.50555 41.7103 44.0164 46.365 46.7544 34.5915Z"
        />
      </path>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="33s"
        values="0.65;0.5;0.8;0.5;0.5;0.7;0.75;0.7;0.6;0.8;0.65"
      />
    </g>
    <g filter="url(#animated-blur-quaternary)">
      <path fill="url(#animated-gradient-tertiary)">
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="33s"
          values="M54.9731 22.8358C65.4818 30.877 67.4822 45.9147 59.441 56.4235C51.3998 66.9322 36.3621 68.9326 25.8533 60.8914C15.3445 52.8502 45.8737 53.2532 53.9149 42.7445C61.9561 32.2357 44.4643 14.7946 54.9731 22.8358Z;M62.9072 30.3373C69.6994 43.6286 64.4308 59.9095 51.1395 66.7017C37.8482 73.4939 21.5673 68.2253 14.7751 54.934C7.98288 41.6427 38.8673 56.8835 52.1586 50.0913C65.4499 43.2991 56.115 17.0459 62.9072 30.3373Z;M64.8779 49.967C60.0109 65.4492 43.5147 74.0545 28.0326 69.1875C12.5505 64.3205 3.94523 47.8243 8.8122 32.3422C13.6792 16.86 26.0035 52.2202 41.4857 57.0872C56.9678 61.9542 66.6791 36.8213 64.8779 49.967Z;M56.8019 55.8185C47.7556 66.9807 31.3733 68.696 20.2111 59.6496C9.04887 50.6032 7.33362 34.221 16.38 23.0587C25.4263 11.8965 24.0633 45.02 35.2256 54.0664C46.3878 63.1127 65.8483 44.6563 56.8019 55.8185Z;M40.5176 61.7033C26.2606 64.1062 12.755 54.4966 10.3521 40.2396C7.94921 25.9826 17.5589 12.477 31.8159 10.0741C46.0729 7.67118 22.997 31.7626 25.3999 46.0196C27.8028 60.2766 54.7746 59.3004 40.5176 61.7033Z;M18.0094 55.1852C7.51094 46.8088 5.79068 31.5077 14.1671 21.0092C22.5435 10.5108 37.8446 8.79052 48.3431 17.1669C58.8416 25.5434 27.8696 24.5057 19.4932 35.0042C11.1168 45.5026 28.5079 63.5616 18.0094 55.1852Z;M11.8305 44.9811C6.95349 31.5496 13.8883 16.7075 27.3198 11.8305C40.7513 6.95352 55.5933 13.8883 60.4704 27.3199C65.3474 40.7514 37.8143 22.6123 24.3828 27.4893C10.9513 32.3663 16.7075 58.4126 11.8305 44.9811Z;M13.5928 33.0499C15.5933 19.2152 28.4304 9.62172 42.2651 11.6223C56.0998 13.6229 65.6932 26.4599 63.6926 40.2946C61.692 54.1293 46.3325 25.7677 32.4978 23.7671C18.6631 21.7665 11.5922 46.8846 13.5928 33.0499Z;M14.735 26.6201C22.5492 12.5624 40.2799 7.50104 54.3376 15.3153C68.3954 23.1295 73.4567 40.8602 65.6425 54.9179C57.8283 68.9756 52.9213 32.1909 38.8635 24.3766C24.8058 16.5624 6.92075 40.6778 14.735 26.6201Z;M28.5844 18.9705C41.6195 12.1181 57.7415 17.1302 64.5939 30.1653C71.4463 43.2004 66.4342 59.3224 53.3991 66.1748C40.364 73.0272 55.0476 42.3844 48.1952 29.3493C41.3428 16.3142 15.5492 25.8229 28.5844 18.9705Z;M54.9731 22.8358C65.4818 30.877 67.4822 45.9147 59.441 56.4235C51.3998 66.9322 36.3621 68.9326 25.8533 60.8914C15.3445 52.8502 45.8737 53.2532 53.9149 42.7445C61.9561 32.2357 44.4643 14.7946 54.9731 22.8358Z"
        />
      </path>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="33s"
        values="0.9;0.9;0.8;0.9;0.88;0.9;0.8;0.85;0.8;0.85;0.9"
      />
    </g>
    <g filter="url(#animated-blur-final)">
      <path fill="url(#animated-gradient-quaternary)">
        <animate
          attributeName="d"
          repeatCount="indefinite"
          dur="33s"
          values="M18.3874 59.2886C6.57539 49.0638 5.2887 31.1995 15.5135 19.3875C25.7383 7.57545 43.6027 6.28876 55.4147 16.5136C67.2267 26.7384 31.2768 24.0896 21.052 35.9016C10.8272 47.7136 30.1994 69.5134 18.3874 59.2886Z;M7.65504 43.291C5.08414 26.733 16.4229 11.226 32.9809 8.6551C49.5389 6.08421 65.0459 17.423 67.6168 33.981C70.1877 50.539 42.615 23.4359 26.057 26.0068C9.49904 28.5777 10.2259 59.8491 7.65504 43.291Z;M20.4478 25.7344C26.2436 12.626 41.5684 6.69806 54.6767 12.4939C67.7851 18.2897 73.713 33.6145 67.9172 46.7228C62.1214 59.8311 54.7869 27.5846 41.6786 21.7888C28.5702 15.993 14.652 38.8427 20.4478 25.7344Z;M23.9807 12.3813C39.5865 6.09565 57.3331 13.6511 63.6188 29.257C69.9044 44.8628 62.349 62.6094 46.7431 68.8951C31.1373 75.1808 51.3597 42.0447 45.074 26.4389C38.7883 10.833 8.37482 18.667 23.9807 12.3813Z;M55.4759 15.4277C69.0201 25.843 71.5566 45.2659 61.1413 58.8101C50.7261 72.3543 31.3031 74.8908 17.7589 64.4755C4.21475 54.0602 43.6329 54.6748 54.0482 41.1306C64.4634 27.5864 43.8292 9.65954 55.4759 15.4277Z;M66.0317 29.6825C72.5314 44.4361 65.8403 61.6653 51.0868 68.1649C36.3332 74.6646 19.1041 67.9735 12.6044 53.22C6.1047 38.4664 38.4625 56.8165 53.2161 50.3169C67.9696 43.8172 59.532 14.929 66.0317 29.6825Z;M66.5483 45.2726C64.7332 61.2919 50.2756 72.8067 34.2563 70.9917C18.2369 69.1766 6.72211 54.719 8.53717 38.6997C10.3522 22.6803 29.0652 54.8297 45.0846 56.6447C61.1039 58.4598 68.3633 29.2533 66.5483 45.2726Z;M60.9713 55.8397C54.5371 69.7354 38.0564 75.7842 24.1607 69.35C10.265 62.9158 4.21619 46.4352 10.6504 32.5394C17.0846 18.6437 24.3225 53.2272 38.2183 59.6613C52.114 66.0955 67.4055 41.9439 60.9713 55.8397Z;M56.5032 62.9668C43.5589 72.9261 24.9918 70.5063 15.0325 57.562C5.07323 44.6177 7.4931 26.0506 20.4374 16.0913C33.3818 6.13202 23.147 42.4 33.1062 55.3443C43.0655 68.2886 69.4475 53.0076 56.5032 62.9668Z;M38.7078 70.8806C21.3359 69.7916 8.13606 54.8262 9.22506 37.4543C10.3141 20.0825 25.2795 6.88264 42.6514 7.97163C60.0232 9.06063 26.3711 30.981 25.2821 48.3528C24.1931 65.7247 56.0796 71.9696 38.7078 70.8806Z;M18.3874 59.2886C6.57539 49.0638 5.2887 31.1995 15.5135 19.3875C25.7383 7.57545 43.6027 6.28876 55.4147 16.5136C67.2267 26.7384 31.2768 24.0896 21.052 35.9016C10.8272 47.7136 30.1994 69.5134 18.3874 59.2886Z"
        />
      </path>
      <animate
        attributeName="opacity"
        repeatCount="indefinite"
        dur="33s"
        values="0.88;0.95;0.95;0.9;0.85;0.9;0.9;0.8;0.83;0.93;0.88"
      />
    </g>
    <g filter="url(#front-reflection-blur)">
      <path
        fill="white"
        fill-opacity="0.9"
        d="M41.499 15.0002C32.8069 18.4809 29.2764 14.9232 22.499 18.5002C12.1144 23.9811 6.92188 40.6533 6.92188 36.1925C6.92188 31.7317 8.36418 17.154 24.8065 8.78877C41.2488 0.423518 50.1911 11.5195 41.499 15.0002Z;M41.499 15.0002C32.8069 18.4809 29.2764 14.9232 22.499 18.5002C12.1144 23.9811 6.92188 40.6533 6.92188 36.1925C6.92188 31.7317 8.36418 17.154 24.8065 8.78877C41.2488 0.423518 50.1911 11.5195 41.499 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.5 15.0002C32.8079 18.4809 29.2774 14.9232 22.5 18.5002C12.1154 23.9811 6.92285 40.6533 6.92285 36.1925C6.92285 31.7317 8.36516 17.154 24.8075 8.78877C41.2498 0.423518 50.1921 11.5195 41.5 15.0002Z;M41.499 15.0002C32.8069 18.4809 29.2764 14.9232 22.499 18.5002C12.1144 23.9811 6.92188 40.6533 6.92188 36.1925C6.92188 31.7317 8.36418 17.154 24.8065 8.78877C41.2488 0.423518 50.1911 11.5195 41.499 15.0002Z;M41.499 15.0002C32.8069 18.4809 29.2764 14.9232 22.499 18.5002C12.1144 23.9811 6.92188 40.6533 6.92188 36.1925C6.92188 31.7317 8.36418 17.154 24.8065 8.78877C41.2488 0.423518 50.1911 11.5195 41.499 15.0002Z"
      />
      <g opacity="0.9">
        <path
          fill="white"
          fill-opacity="0.9"
          d="M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z;M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z;M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z;M61.9949 27.1394C57.6125 22.8903 60.1769 25.3557 56.178 21.5793C53.8785 19.4076 51.6533 17.3562 51.6177 16.2506C51.582 15.145 51.2568 13.6814 55.5706 13.677C65.447 16.3758 66.3774 31.3886 61.9949 27.1394Z;M61.9949 27.1394C57.6125 22.8903 60.1769 25.3557 56.178 21.5793C53.8785 19.4076 51.6533 17.3562 51.6177 16.2506C51.582 15.145 51.2568 13.6814 55.5706 13.677C65.447 16.3758 66.3774 31.3886 61.9949 27.1394Z;M61.9949 27.1394C57.6125 22.8903 60.1769 25.3557 56.178 21.5793C53.8785 19.4076 51.6533 17.3562 51.6177 16.2506C51.582 15.145 51.2568 13.6814 55.5706 13.677C65.447 16.3758 66.3774 31.3886 61.9949 27.1394Z;M61.9949 27.1394C57.6125 22.8903 60.1769 25.3557 56.178 21.5793C53.8785 19.4076 51.6533 17.3562 51.6177 16.2506C51.582 15.145 51.2568 13.6814 55.5706 13.677C65.447 16.3758 66.3774 31.3886 61.9949 27.1394Z;M61.9949 27.1394C57.6125 22.8903 60.1769 25.3557 56.178 21.5793C53.8785 19.4076 51.6533 17.3562 51.6177 16.2506C51.582 15.145 51.2568 13.6814 55.5706 13.677C65.447 16.3758 66.3774 31.3886 61.9949 27.1394Z;M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z;M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z;M61.9959 27.1394C57.6135 22.8903 60.1779 25.3557 56.179 21.5793C53.8795 19.4076 51.6543 17.3562 51.6186 16.2506C51.583 15.145 51.2578 13.6814 55.5716 13.677C65.4479 16.3758 66.3783 31.3886 61.9959 27.1394Z"
        />
      </g>
    </g>
  </svg>
</template>
